// src/App.js
// Updated: 10/19/2025 12:15 AM

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from 'react-hot-toast';

// Import Pages
import AuthPage from './pages/AuthPage';
import HomePage from './pages/HomePage';
import DashboardPage from './pages/DashboardPage';
import EventDetailPage from './pages/EventDetailPage';
import RegistrationPage from './pages/RegistrationPage';
import ProfilePage from './pages/ProfilePage';
import FamilyTreePage from './pages/FamilyTreePage';
import NotFoundPage from './pages/NotFoundPage';
import OnboardingPage from './pages/OnboardingPage';
import FamilyDirectoryPage from './pages/FamilyDirectoryPage';
import FamilyGalleryPage from './pages/FamilyGalleryPage'; // <-- Added import

// Import Components
import PrivateRoute from './components/common/PrivateRoute';
import OnboardingRoute from './components/common/OnboardingRoute';
import { FamilyProvider } from './context/FamilyContext';

function App() {
  return (
    <AuthProvider>
      <FamilyProvider>
        <Router>
          <Toaster position="top-center" reverseOrder={false} />
          <Routes>
            {/* Public Route */}
            <Route path="/login" element={<AuthPage />} />

            {/* Private Routes */}
            <Route path="/" element={<PrivateRoute><HomePage /></PrivateRoute>} />
            <Route path="/onboarding" element={<OnboardingRoute><OnboardingPage /></OnboardingRoute>} />
            <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
            <Route path="/event/:eventId" element={<PrivateRoute><EventDetailPage /></PrivateRoute>} />
            <Route path="/event/:eventId/register" element={<PrivateRoute><RegistrationPage /></PrivateRoute>} />
            <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
            <Route path="/family-tree" element={<PrivateRoute><FamilyTreePage /></PrivateRoute>} />
            <Route path="/directory" element={<PrivateRoute><FamilyDirectoryPage /></PrivateRoute>} />
            <Route path="/gallery" element={<PrivateRoute><FamilyGalleryPage /></PrivateRoute>} /> {/* <-- Added route */}


            {/* Not Found Route */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Router>
      </FamilyProvider>
    </AuthProvider>
  );
}

export default App;